export default __webpack_public_path__ + "static/media/circle.67f171d6.png";